export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";